<template>
  <div>
    <div class="col-12 p0 py2 my1 break-word">
      <h2 class="m0 caps">
        Options
      </h2>
      <span class="h3 m0">Sélectionner options pour <span class="bold">{{ currentParticipant.firstname }} {{ currentParticipant.lastname }}</span></span>
    </div>

    <div class="col-12 white-bg p2">
      <div class="flex flex-wrap">
        <div class="col-7">
          <h3 class="bold h1 m0 cond lower">{{ currentParticipant.tariff.label.toLowerCase() }}</h3>
        </div>
        <div class="col-5 right-align">
          <div v-if="price > 0">
            <span :class="['bold h1 m0', { 'crossed': showPromo }]">{{ price }} € </span>
            <span v-if="showPromo" class="bold h1 m0"> {{ promoPrice }} €</span>
            <span v-if="isRecurring" class="h3">/ mois</span>
          </div>
          <!-- <span v-if="price > 0" class="bold h1 m0">{{ price }} € <span v-if="isRecurring" class="h3">/ mois</span></span> -->
          <span v-else class="bold h2 m0">OFFERT</span>
        </div>
      </div>

      <!-- MANDATORY OPTIONS -->
      <div v-if="optionsByType(optionTypes.MANDATORY).length" class="my2">
        <h3 class="bold h3 border-bottom">Obligatoire</h3>
        <OptionLine
          v-for="(option, index) in optionsByType(optionTypes.MANDATORY)"
          :key="index"
          :option="option"
          :is-active="isOptionActive(option)"
          :radio-id="`mandatory-${index}`"
          @manageOption="manageOption"
        />
      </div>

      <!-- OPTIONAL OPTIONS -->
      <div v-if="optionsByType(optionTypes.OPTIONAL).length" class="my2">
        <h3 class="bold h3 border-bottom">Suppléments</h3>
        <OptionLine
          v-for="(option, index) in optionsByType(optionTypes.OPTIONAL)"
          :key="`${index} ${option.name} ${option.optionType}`"
          :option="option"
          :is-active="isOptionActive(option)"
          :radio-id="`optional-${index}`"
          @manageOption="manageOption"
        />
      </div>
    </div>

    <div class="flex flex-wrap">
      <div class="col-12 py3 flex justify-end items-center">
        <Button class="col-4 sm-col-12" :action="handleBack" text="Precedent" color="grey-bg" />
        <Button v-if="!loading" id="button-confirm-options" class="col-4 sm-col-12 ml2" :action="confirmOptions" text="Suivant" />
        <Button v-else class="col-4 sm-col-6 ml2" :disabled="true" icon="icon icon-loader" />
      </div>
    </div>
  </div>
</template>

<script>
import { isWithinInterval, format } from 'date-fns';
import OptionLine from '../../components/options/OptionLine';
import Button from '../../components/elements/Button';

import { changeToPage, injectCurrentParticipant, computePromo } from '@/utils/logics';
import { optionTypes } from '@/utils/utils';

export default {
  components: {
    OptionLine,
    Button
  },
  data () {
    return {
      loading: false,
      optionTypes: optionTypes,
      currentParticipant: this.$store.state.currentParticipant,
      participantOptions: [],
      offerInfo: this.$store.state.offerInfo || null,
      availableOptions: this.$store.state.availableOptions
    };
  },
  computed: {
    isOfferStage () {
      const offer = this.$store.state.offerInfo;
      return offer && offer.detail ? offer.detail.stage || offer.detail.stage1D : false;
    },
    isInternalSession () {
      return this.$store.state.siteInfo.is_internal_session;
    },
    price () {
      const { tariff } = this.currentParticipant;

      return parseFloat(tariff.price / 100).toFixed(2);
    },
    promoPrice () {
      return computePromo(this.currentParticipant.tariff).price ? (computePromo(this.currentParticipant.tariff).price / 100).toFixed(2) : null;
    },
    showPromo () {
      return computePromo(this.currentParticipant.tariff).canShow;
    },
    options () {
      const computedOptions = [];

      if (this.offerInfo && this.offerInfo.options) {
        this.availableOptions.map(option => {
          const price = option.detail.prices.find(priceAux => {
            if (this.isInternalSession) {
              return priceAux.priceCategory.uuid === this.currentParticipant.tariff.priceCategory.uuid && priceAux.period.uuid === this.currentParticipant.tariff.period.uuid;
            }
            return priceAux.tariffCategoryCode === this.currentParticipant.tariff.tariffCategoryCode;
          });
          if (price) {
            if (price.promotions && price.promotions.length) {
              option.promo = {};

              price.promotions.map(promo => {
                const startDate = new Date(promo.start_date);
                const endDate = new Date(promo.end_date);
                const now = new Date();
                let day_week = format(now, 'e');

                if (day_week === 1) {
                  day_week = 7;
                } else {
                  day_week -= 1;
                }

                const isBetween = isWithinInterval(now, {
                  start: startDate,
                  end: endDate
                });

                if (isBetween /* && promo.quantity_remaining > 0 */ && (promo.week_day === 0 || promo.week_day === day_week)) { // TODO uncomment when correctly receiving quantity remaining
                  option.price = promo.price.toFixed(2);
                  option.promo = promo;
                }
                return promo;
              });
            }
            computedOptions.push({
              ...option,
              price
            });
          }
          return null; // ESLint need to desativate array-callback-return rule
        });
      }

      return computedOptions;
    },
    isRecurring () {
      return this.offerInfo.detail.recurring;
    },
    getOfferPrices () {
      const offer = this.$store.state.offerInfo;
      return offer && offer.detail ? offer.detail.prices : [];
    }
  },
  async created () {
    // Initialize the participant options with the mandatory ones
    // This way we can change the quantity directly on this array
    this.participantOptions = this.optionsByType(this.optionTypes.MANDATORY);
    if (!this.options.length) {
      this.confirmOptions();
    }
  },
  methods: {
    changeToPage,
    injectCurrentParticipant,
    optionsByType (type) {
      return this.options.filter(option => option.optionType === type).map(option => {
        option.quantity = option.quantity ? parseInt(option.quantity) : 1;
        option.fixedQuantity = this.isOfferStage ? true : option.fixedQuantity;
        return option;
      });
    },
    manageOption (option) {
      let optionIndex = null;
      if (this.isInternalSession) {
        optionIndex = this.participantOptions.findIndex(o => o.product_uuid === option.product_uuid);
      } else {
        optionIndex = this.participantOptions.findIndex(o => o.horanet_product.horanet_product_code === option.horanet_product.horanet_product_code && o.optionType === option.optionType);
      }

      if (optionIndex !== -1) {
        // if this event is called and the quantity didn't change then it's to remove
        // if the quantity is zero and the option is optional, the option is removed from the participant's options
        if (option.quantity === this.participantOptions[optionIndex].quantity || (option.quantity === 0 && option.optionType === this.optionTypes.OPTIONAL)) {
          this.participantOptions.splice(optionIndex, 1);
        } else {
          // updates the option
          this.participantOptions[optionIndex] = option;
        }
      } else if (option.quantity > 0) {
        this.participantOptions.push(option);
      }
    },
    isOptionActive (option) {
      if (this.isInternalSession) {
        return this.participantOptions.some(o => o.product_uuid === option.product_uuid);
      }
      const { horanet_product } = option;
      return this.participantOptions.some(o => o.horanet_product.horanet_product_code === horanet_product.horanet_product_code && o.optionType === option.optionType);
    },
    async confirmOptions () {
      this.loading = true;
      this.currentParticipant.options = this.participantOptions;

      const insuranceOption = this.currentParticipant.options.find(o => o.detail.insurance);

      if (insuranceOption) {
        this.currentParticipant.insuranceInfo = { ...insuranceOption.detail.insuranceDetail };
      }

      await this.injectCurrentParticipant({ ...this.currentParticipant, quantity: 1 });
      this.loading = false;
    },
    handleBack () {
      this.changeToPage(this.getOfferPrices.length > 1 ? 'Tariffs' : 'AddParticipant'); // TODO implement this with Documents page
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
